export const normalizeApiError = (error, fallbackMessage = "Terjadi kesalahan saat menghubungi server.") => {
  const responseData = error?.response?.data;
  const responseMessage =
    typeof responseData === "string"
      ? responseData
      : responseData?.message || responseData?.error;

  return {
    message: responseMessage || error?.message || fallbackMessage,
    status: error?.response?.status ?? null,
    details: typeof responseData === "object" ? responseData : null,
  };
};
